import React, { useState, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  Panel,
  Row,
  Col,
  Grid,
  Input,
  ControlLabel,
  Button,
} from 'rsuite'
import AppContext from '../../../context/AppContext'
import './styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../../utils/ValidatorUtils'
import classNames from 'classnames'
import { isEmpty, findIndex } from 'lodash'
import {
  getMasterReservedWord,
  saveMasterReservedWord,
  updateMasterReservedWord,
  deleteMasterReservedWord,
} from '../../../redux/actions/masterReservedWord'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  addMasterDataBy,
  deleteMasterDataBy,
  searchMasterDataBy,
} from '../../../redux/actions/manageMasterData'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import notification from '../../../utils/notification'
import { SAVE_FAILED_MSG } from '../../../constants/msgText'

export default function TableManage({
  schema,
  single,
  onSingleSubmit = () => {},
  onReload,
  pagination,
  lengthMenu,
  onSelectProject,
  rowCanEdit,
  title,
  table,
  isShowSequence,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [selectList, setSelectList] = useState([])
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const contextValue = React.useContext(AppContext)
  const [tableData, setTableData] = useState([])
  const [inputValueName, setInputValueName] = useState('')
  const [expand, setExpand] = useState(true)
  const [loading, setloading] = useState(false)
  const [totalSize, setTotalSize] = useState(schema.totalSize)

  const [localSchema, setLocalSchema] = useState(schema)

  useEffect(() => {
    setLocalSchema(schema)
    if (pagination && typeof onReload !== 'function') {
      const data = getData(schema, 1, 5)
      setTableData(data)
    } else {
      setTableData(schema.values || [])
    }
  }, [schema, pagination, onReload])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleCallApiUpdate = async (request) => {
    startLoading()
    setloading(true)
    try {
      const response = await addMasterDataBy(request)
      // console.log('response = ', response.model)
      if (response.model) {
        handleSearchManageMasterData()
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleCallApiDelete = async () => {
    startLoading()
    setloading(true)
    try {
      const response = await deleteMasterDataBy(table, deleteObj.id)
      // console.log('delete => ', response)
      if (response) {
        handleSearchManageMasterData(5, 1, '')
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    handleSearchManageMasterData(dataKey, 1, inputValueName)
    // if (typeof onReload === 'function') {
    //   onReload(dataKey, 1, inputValueName)
    // } else {
    //   if (pagination && typeof onReload !== 'function') {
    //     setTableData(getData(localSchema, 1, dataKey))
    //   } else {
    //     setTableData(localSchema?.values || [])
    //   }
    // }
  }

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage 111 page', dataKey)

    setPage(dataKey)
    handleSearchManageMasterData(displayLength, dataKey, inputValueName)
    // if (typeof onReload === 'function') {
    //   // onReload(displayLength, dataKey, inputValueName)
    //   // pageNumber: pagenumber || 1,
    //   //   pageSize: pagesize || 5,
    //   handleSearchManageMasterData(displayLength, dataKey, inputValueName)
    // } else {
    //   if (pagination && typeof onReload !== 'function') {
    //     setTableData(getData(localSchema, dataKey, displayLength))
    //   } else {
    //     setTableData(localSchema?.values || [])
    //   }
    // }
  }

  const getData = (schema, page, displayLength) => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangeSearchValue = (val) => {
    setInputValueName(val)
  }

  const handleSearchProject = () => {
    handleSearchManageMasterData(5, 1, inputValueName)
    setPage(1)
  }

  const [data, setData] = React.useState(tableData.filter((v, i) => i < 8))

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data)
    nextData.find((item) => item.id === id)[key] = value
    // setData(nextData)
  }

  const handleChangeEditStatus = async (rowData) => {
    var newData = tableData.map((item) => {
      if (item.status) {
        delete item.status
      }

      if (item.id === rowData.id) {
        let newItem = {
          ...item,
          status: rowData.status ? null : 'EDIT',
        }
        return newItem
      }
      return item
    })

    setTableData(newData)
  }

  const handleCancelSearchProject = () => {
    setInputValueName('')
    handleSearchManageMasterData(5, 1, '')
    setPage(1)
  }

  const onSubmit = (data, rowData) => {
    console.log('data => ', data)
    console.log('is empty => ', isEmpty(data.input_name))

    if (isEmpty(data.input_name)) {
      notification.open('error', {
        title: SAVE_FAILED_MSG,
        duration: 5000,
      })
    }

    let request = {
      tableName: table,
      id: rowData.id || null,
      name: data.input_name || '',
      sequence: data.input_sequence || 0,
    }

    handleCallApiUpdate(request)
  }

  const handleDelete = (rowData) => {
    console.log('row dat => ', rowData)
    setIsShowConfirm(true)
    setDeleteObj(rowData)
  }

  const EditCell = ({ rowData, dataKey, onChange, ...props }) => {
    // console.log('pppp ', props.rowIndex)
    const editing = rowData.status === 'EDIT'
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <Input
            // className={classNames('rs-input', errors[`input_name_${props.rowIndex}`] && 'is-error')}
            // name={`input_name_${props.rowIndex}`}
            name={`input_name`}
            defaultValue={rowData[dataKey]}
            inputRef={register()}
            // inputRef={register(
            //   isValidators([
            //     {
            //       type: 'REQUIRED',
            //       value: null,
            //       errorMessage: 'กรุณาเพิ่มรายการ',
            //     },
            //   ])
            // )}
            // onChange={(value) => {
            //   setValue(rowData.id, value)
            // }}
          />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    )
  }

  const EditCellNumber = ({ rowData, dataKey, onChange, ...props }) => {
    const editing = rowData.status === 'EDIT'
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <Input
            // className={classNames('rs-input', errors[rowData.id] && 'is-error')}
            name={`input_sequence`}
            defaultValue={rowData[dataKey]}
            type="number"
            inputRef={register()}
            // inputRef={register(
            //   isValidators([
            //     {
            //       type: 'REQUIRED',
            //       value: null,
            //       errorMessage: 'กรุณาเพิ่มรายการ',
            //     },
            //   ])
            // )}
            // onChange={(value) => {
            //   setValue(rowData.id, value)
            // }}
          />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    )
  }

  const handleSearchManageMasterData = async (pagesize, pagenumber, keyword) => {
    startLoading()
    setloading(true)
    try {
      const request = {
        tableName: table,
        name: keyword || '',
        pageNumber: pagenumber || 1,
        pageSize: pagesize || 5,
      }

      // console.log('request => ', request)

      const response = await searchMasterDataBy(request)

      if (response) {
        setTableData(response.model.values || [])
        setTotalSize(response.model.totalSize || 0)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  return (
    <>
      <br />
      {loading && <OverlayLoader />}

      <Panel shaded header={schema?.header} collapsible defaultExpanded>
        {schema?.searchForm?.name && (
          <Grid fluid>
            <Row gutter={16}>
              <Col xs={6}>
                <ControlLabel>{schema?.searchForm.name.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema?.searchForm.name.name}
                  value={inputValueName}
                  placeholder={
                    schema?.searchForm.name.hint || `ระบุ${schema?.searchForm.name.label}`
                  }
                  onChange={handleChangeSearchValue}
                ></Input>
              </Col>
              <Col xs={6}>
                <div>
                  <br />
                  <Button
                    size="sm"
                    color="green"
                    appearance="ghost"
                    style={{ width: '40%', height: '35px' }}
                    onClick={handleSearchProject}
                  >
                    {schema?.searchForm.name.buttonSearchText || 'ค้นหา'}
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    size="sm"
                    color="yellow"
                    appearance="ghost"
                    style={{ width: '40%', height: '35px' }}
                    onClick={handleCancelSearchProject}
                  >
                    {schema?.searchForm.name.buttonCancelText || 'ยกเลิก'}
                  </Button>
                </div>
              </Col>
            </Row>
          </Grid>
        )}

        <Table
          wordWrap
          height={400}
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
        >
          <Column align="center" width={100} fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1 + (page * displayLength - displayLength)
              }}
            </Cell>
          </Column>

          <Column flexGrow={1}>
            <HeaderCell>รายการ</HeaderCell>
            <EditCell dataKey="name" onChange={handleChange} />
          </Column>

          {isShowSequence && (
            <Column width={150} align="center">
              <HeaderCell>เรียงลำดับ</HeaderCell>
              <EditCellNumber dataKey="sequence" onChange={handleChange} />
            </Column>
          )}

          <Column width={220} align="center">
            <HeaderCell>แก้ไขล่าสุด</HeaderCell>
            <Cell dataKey="lastUpdate" />
          </Column>

          {rowCanEdit ? (
            <Column width={250} align="center" fixed="right">
              <HeaderCell></HeaderCell>

              <Cell>
                {(rowData) => {
                  if (rowData.status === 'EDIT') {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={
                            <Icon appearance="ghost" icon="save" className="bt-gost-icon-radius" />
                          }
                          onClick={handleSubmit((data) => {
                            // console.log(data)
                            onSubmit(data, rowData)
                          })}
                        >
                          บันทึก
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={
                            <Icon
                              appearance="ghost"
                              icon="close"
                              className="bt-gost-icon-none-radius-cancel"
                            />
                          }
                          // onClick={() => handleChangeEditStatus(rowData)}
                          onClick={() => {
                            handleCancelSearchProject()
                          }}
                        >
                          ยกเลิก
                        </IconButton>
                      </ButtonGroup>
                    )
                  } else {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={
                            <Icon
                              appearance="ghost"
                              icon="edit"
                              className="bt-gost-icon-radius-edit"
                            />
                          }
                          onClick={() => handleChangeEditStatus(rowData)}
                        >
                          แก้ไข
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={
                            <Icon
                              appearance="ghost"
                              icon="trash-o"
                              className="bt-gost-icon-none-radius-cancel"
                            />
                          }
                          onClick={() => handleDelete(rowData)}
                        >
                          ลบ
                        </IconButton>
                      </ButtonGroup>
                    )
                  }
                }}
              </Cell>
            </Column>
          ) : (
            <Column width={150} align="center" fixed="right">
              <HeaderCell>
                <span></span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={
                          <Icon
                            icon={schema.buttonTable.singleIcon}
                            className="bt-gost-icon-radius"
                          />
                        }
                        onClick={() => {
                          onSelectProject(rowData.projectVersionId)
                        }}
                      >
                        {schema.buttonTable.buttonText}
                      </IconButton>
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={lengthMenu || defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}

        {schema?.message && (
          <Row>
            <Message showIcon type={schema.message.type} description={schema.message.message} />
          </Row>
        )}

        <ConfirmWidget
          title={`ยืนยันการลบรายการ`}
          show={isShowConfirm}
          detail={`ยืนยันการลบ ${
            deleteObj?.projectName ? schema.projectNameText + ' : ' + deleteObj.projectName : ''
          }`}
          onCancle={() => {
            setIsShowConfirm(false)
            setDeleteObj({})
          }}
          onConfirm={() => {
            handleCallApiDelete()
            let total = schema.values.length
            let newPage = Math.ceil(total / displayLength)
            if (newPage > 0 && newPage < page) {
              setPage(newPage)
            }
            setIsShowConfirm(false)
          }}
        />
      </Panel>
    </>
  )
}
